import { Component } from 'react'
import IconSVG from 'svg-inline-react'
import closeSrc from '!svg-inline?removeSVGTagAttrs=false&removeTags=true!images/navigation/close.svg'

require('./style.styl')

export default class AccountCallToActionPane extends Component {
  render() {
    const { isDisabled, ctaTitle, ctaDescription, buttonLabel, handleClick, handleDismiss } = this.props
    const disabledClass = isDisabled ? 'disabled-account' : ''
    return (
      <div className={ `${disabledClass} PlanCta`} >
        <h3 className="dsg-h3 title">{ ctaTitle }</h3>
        <div className="dsg-Body description">{ ctaDescription }</div>
        <button className="drift-button drift-button-primary large" style={{ maxWidth: '14rem' }} onClick={handleClick}>{buttonLabel}</button>
        <IconSVG className="close-button" src={closeSrc} onClick={handleDismiss}/>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/GlobalNotificationBar/components/AccountCallToActionPane/index.js